import { createResource } from 'react-resource-router';

import { checkIfWorkspaceLinked } from 'src/sections/global/components/unlinked-workspace-notifications';

export const loadWorkspaceLinkedResource = createResource({
  type: 'workspace-linked',
  getKey: ({ match }) => match?.params?.workspaceSlug || 'workspace-linked',
  maxAge: 60000,
  getData: async ({ match }) => {
    const { workspaceSlug: workspaceSlugParam, repositoryOwner } = match.params;
    const workspaceSlug = repositoryOwner || workspaceSlugParam;

    if (!workspaceSlug) return null;

    const isWorkspaceLinked = await checkIfWorkspaceLinked(workspaceSlug);

    return isWorkspaceLinked;
  },
});
